var map = {
	"./icon-amex.svg": "03d8",
	"./icon-default.svg": "01ca",
	"./icon-diners.svg": "d990",
	"./icon-discover.svg": "0210",
	"./icon-jcb.svg": "b32f",
	"./icon-mastercard.svg": "b5ca",
	"./icon-unionpay.svg": "2b65",
	"./icon-visa.svg": "353f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9796";